import React, { HTMLAttributes, PropsWithChildren } from 'react';

import styles from '../styles.module.css';
export interface AccordionItemProps
  extends PropsWithChildren<HTMLAttributes<HTMLDivElement>> {
  active?: boolean;
}

export const AccordionItem: React.FC<AccordionItemProps> = ({
  children,
  active = false,
  ...props
}) => {
  return (
    <section
      className={`${styles.accordionItem} ${active ? styles.active : ''}`}
      {...props}
    >
      {children}
    </section>
  );
};
